import { Box, Typography, styled } from "@mui/material"

export const LoaderContainer = styled(Box)(() => ({
  display: "flex",
  alignSelf: "center",
  justifyContent: "center",
  position: "absolute",
  top: "calc(50% - 22.5px)",
}))

export const ErrorContainer = styled(Box)(() => ({
  display: "flex",
  alignSelf: "center",
  justifyContent: "center",
  margin: "32px",
  padding: "0 10%",
  position: "relative",
  width: "100%",
}))

export const Headline = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}))

export const Title = styled(Typography)(() => ({
  margin: "7px 0",
}))

export const Description = styled(Typography)(() => ({
  margin: "12px 0",
  textAlign: "center",
}))
